(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neon-cart"] && !Shopify.designMode) return;
  try {
    
function initializeNeonCart(scope){scope.querySelectorAll('[data-neon-cart]').forEach(function(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const form=root.querySelector('.nc-form');if(!form)return;const update=root.querySelector('.nc-update'),note=root.querySelector('[data-cart-update-note]');update.disabled=true;function changed(){update.disabled=false;note.hidden=false}form.addEventListener('input',changed);root.querySelectorAll('[data-cart-step]').forEach(function(button){button.addEventListener('click',function(){const input=button.closest('.nc-quantity').querySelector('input');input.value=String(Math.max(0,Math.trunc(Number(input.value)||0)+Number(button.dataset.cartStep)));changed()})})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initializeNeonCart(document)},{once:true});else initializeNeonCart(document);document.addEventListener('shopify:section:load',function(event){initializeNeonCart(event.target)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neon-customizer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('neon-studio-frame')) {
  class NeonStudioFrame extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      if (!CSS.supports('background', 'conic-gradient(#000,#fff)') || !(CSS.supports('mask-composite', 'exclude') || CSS.supports('-webkit-mask-composite', 'xor'))) return;
      this.cleanup = new AbortController();
      this.button = this.closest('.eg-at')?.querySelector('[data-frame-toggle]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = true;
      this.inView = false;
      this.update = () => {
        this.toggleAttribute('data-frame-running', this.enabled && this.inView && !this.motion.matches && document.visibilityState === 'visible');
        if (this.button) {
          this.button.hidden = this.motion.matches;
          this.button.setAttribute('aria-pressed', String(this.enabled));
          this.button.setAttribute('aria-label', this.enabled ? this.button.dataset.pauseLabel : this.button.dataset.resumeLabel);
        }
      };
      this.button?.addEventListener('click', () => {
        this.enabled = !this.enabled;
        this.update();
      }, { signal: this.cleanup.signal });
      this.motion.addEventListener('change', this.update, { signal: this.cleanup.signal });
      document.addEventListener('visibilitychange', this.update, { signal: this.cleanup.signal });
      this.sizeObserver = new ResizeObserver(([entry]) => {
        const { width, height } = entry.contentRect;
        const diameter = Math.ceil(Math.hypot(width, height) + 16);
        this.style.setProperty('--eg-frame-diameter', `${diameter}px`);
      });
      this.sizeObserver.observe(this);
      this.viewObserver = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.update();
      });
      this.viewObserver.observe(this);
      this.update();
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.sizeObserver?.disconnect();
      this.viewObserver?.disconnect();
      this.cleanup = null;
    }
  }
  customElements.define('neon-studio-frame', NeonStudioFrame);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neon-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('neon-newsletter'))customElements.define('neon-newsletter',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
    const dialog=this.querySelector('dialog'),inline=this.querySelector('.nn-inline'),panel=this.querySelector('.nn-panel'),open=this.querySelector('[data-newsletter-open]');
    if(!dialog||!inline||!panel||!open)return;
    const success=panel.querySelector('[data-newsletter-success]');const feedback=panel.querySelector('[role=alert]');
    const storageKey='everbloom-newsletter-dismissed-v1';let dismissed=0;try{dismissed=Number(localStorage.getItem(storageKey)||0);}catch(e){}
    if(success){try{localStorage.setItem(storageKey,String(Date.now()));}catch(e){}success.focus({preventScroll:true});}
    const show=()=>{if(dialog.open)return;this.previousFocus=document.activeElement;dialog.append(panel);panel.querySelectorAll('[data-newsletter-close]').forEach(button=>button.hidden=false);dialog.showModal();panel.querySelector('input[type=email]')?.focus({preventScroll:true});};
    const close=()=>dialog.close();open.hidden=false;open.addEventListener('click',show,options);
    panel.querySelectorAll('[data-newsletter-close]').forEach(button=>button.addEventListener('click',close,options));
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)close();},options);
    dialog.addEventListener('close',()=>{inline.append(panel);panel.querySelectorAll('[data-newsletter-close]').forEach(button=>button.hidden=true);try{localStorage.setItem(storageKey,String(Date.now()));}catch(e){}this.offered=true;this.previousFocus?.focus({preventScroll:true});},options);
    const offer=()=>{if(this.offered||dialog.open||document.hidden)return;const target=document.activeElement;if(target?.matches('input,textarea,select')||target?.closest('#studio,dialog[open]'))return;const max=document.documentElement.scrollHeight-innerHeight;if(max>0&&scrollY/max>.35){this.offered=true;show();}};
    this.timer=setTimeout(()=>{if(this.dataset.popup!=='true'||success||feedback||Date.now()-dismissed<7*86400000||window.Shopify?.designMode)return;window.addEventListener('scroll',offer,{...options,passive:true});offer();},20000);
    if(feedback)feedback.focus?.({preventScroll:true});
  }
  disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();const dialog=this.querySelector('dialog');if(dialog?.open)dialog.close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neon-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('neon-welcome-ticker'))customElements.define('neon-welcome-ticker',class extends HTMLElement{
connectedCallback(){this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};const button=this.querySelector('.ev-welcome-toggle');if(!button)return;this.motion=matchMedia('(prefers-reduced-motion:reduce)');const sync=()=>{const paused=this.classList.contains('is-paused');button.hidden=this.motion.matches;button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);};button.addEventListener('click',()=>{this.classList.toggle('is-paused');sync();},options);this.motion.addEventListener('change',sync,options);sync();this.classList.add('is-ready');}
disconnectedCallback(){this.controller?.abort();}
});
if(!customElements.get('neon-navigation'))customElements.define('neon-navigation',class extends HTMLElement{
connectedCallback(){this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};const menu=this.querySelector('details');if(!menu)return;const trigger=menu.querySelector('summary');const close=()=>{menu.open=false;};
this.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){close();trigger.focus();}},options);
document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))close();},options);
menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',close,options));
this.desktop=matchMedia('(min-width:1241px)');this.desktop.addEventListener('change',event=>{if(event.matches)close();},options);}
disconnectedCallback(){this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neon-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('neon-hero-showcase')) {
  customElements.define('neon-hero-showcase', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const trigger = this.querySelector('[data-showcase-open]');
      const close = this.querySelector('[data-showcase-close]');
      const dialog = this.querySelector('dialog');
      const video = this.querySelector('video');
      if (!trigger || !close || !dialog || !video) return;
      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        dialog.showModal();
        video.play().catch(() => {});
      }, options);
      close.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        video.pause();
        if (video.readyState > 0) video.currentTime = 0;
        trigger.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      const dialog = this.querySelector('dialog');
      if (dialog?.open) dialog.close();
      this.controller?.abort();
    }
  });
}

if (!customElements.get('neon-hero-loop')) {
  customElements.define('neon-hero-loop', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const video = this.querySelector('video');
      const toggle = this.querySelector('[data-loop-toggle]');
      if (!video || !toggle) return;
      this.video = video;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      const canAutoplay = () => this.dataset.autoplay !== 'false' && !this.motion.matches && !navigator.connection?.saveData;
      const sync = () => {
        const playing = !video.paused && !video.ended;
        this.classList.toggle('is-playing', playing);
        toggle.querySelector('[data-loop-status]').textContent = video.error ? this.dataset.retryText : (playing ? this.dataset.pauseText : this.dataset.playText);
        toggle.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        toggle.setAttribute('aria-pressed', String(playing));
        toggle.querySelector('[data-loop-play]').toggleAttribute('hidden', playing);
        toggle.querySelector('[data-loop-pause]').toggleAttribute('hidden', !playing);
      };
      const play = () => video.play().catch(() => sync());
      video.addEventListener('playing', () => { this.classList.add('is-ready'); sync(); }, options);
      video.addEventListener('pause', sync, options);
      video.addEventListener('error', () => { this.classList.remove('is-ready'); sync(); }, options);
      toggle.addEventListener('click', () => {
        if (video.paused || video.error) { this.userPaused = false; if(video.error)video.load(); play(); }
        else { this.userPaused = true; video.pause(); }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (this.inView && canAutoplay() && !this.userPaused) play();
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { video.pause(); this.classList.remove('is-ready'); }
        else if (this.inView && !document.hidden && !this.userPaused && canAutoplay()) play();
      }, options);
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        if (!this.inView) video.pause();
        else if (!document.hidden && canAutoplay() && !this.userPaused) play();
      }, {threshold: 0.1});
      this.observer.observe(this);
      toggle.hidden = false;
      if (video.readyState >= 2 && !video.paused) this.classList.add('is-ready');
      if (!canAutoplay()) video.pause();
      sync();
      if (canAutoplay() && !document.hidden) play();
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
